export enum LaunchTypes {

    newWindow = 'NEW_WINDOW',
    videoPopup = 'VIDEO_POPUP',
    imagePopup = 'IMAGE_POPUP'

}
